import React, {useEffect, useState} from "react";

import {Tooltip} from "@mui/material";

export const PartScrollButton = ({selected, section, onSelect}) => {
    const [showTooltip, setShowTooltip] = useState(selected);

    /**
     * For each selected button, show the tooltip of that button
     */
    useEffect(() => {
        setShowTooltip(selected);
    }, [selected])

    return (
        <div className='pl-7 row no-gutters justify-content-end' onClick={() => onSelect(Object.keys(section)[0])}
             onMouseEnter={() => setShowTooltip(true)}
        >
            <div className='my-0 scroll-button'>
                <Tooltip
                    arrow={false}
                    classes={{
                        popper: `scroll-button-popper`,
                        tooltip: `scroll-button-tooltip  ${selected ? 'selected' : ''}`
                    }}
                    open={selected ? selected : showTooltip}
                    title={section[Object.keys(section)[0]]}
                    placement={'left'}
                    onMouseEnter={() => setShowTooltip(true)}
                    leaveDelay={selected ? (1000000 * 1000000) : 100}
                    onClose={selected ? () => {
                    } : () => setShowTooltip(false)}
                >
                    <div className={`s-button ${selected ? 'selected' : ''}`}
                         onClick={() => onSelect(Object.keys(section)[0])}/>
                </Tooltip>
            </div>
        </div>

    )
}

export const WarrantyAndReturnProcessSettingsScrollButton = ({selected, section, onSelect}) => {
    const [showTooltip, setShowTooltip] = useState(selected);

    /**
     * For each selected button, show the tooltip of that button
     */
    useEffect(() => {
        setShowTooltip(selected);
    }, [selected])

    return (
        <div className='pl-7 row no-gutters justify-content-end z-index-100' onClick={() => onSelect(section)}
             onMouseEnter={() => setShowTooltip(true)}
        >
            <div className='my-0 scroll-button'>
                <Tooltip
                    arrow={false}
                    classes={{
                        popper: `scroll-button-popper part-support-process-view`,
                        tooltip: `scroll-button-tooltip  ${selected ? 'selected' : ''}`
                    }}
                    open={selected ? selected : !!showTooltip}
                    title={section?.name ?? 'Not Specified'}
                    placement={'right-start'}
                    onMouseEnter={() => setShowTooltip(true)}
                    leaveDelay={selected ? (1000000 * 1000000) : 100}
                    onClose={selected ? () => {
                    } : () => setShowTooltip(false)}
                >
                    <div className={`s-button ${selected ? 'selected' : ''}`}
                         onClick={() => onSelect(section)}/>
                </Tooltip>
            </div>
        </div>

    )
}

export default PartScrollButton;
